import Cookies from "js-cookie";
import type { StateStorage } from "zustand/middleware";

const cookieStorage: StateStorage = {
  removeItem(key) {
    Cookies.remove(key);
  },
  setItem(key, value) {
    Cookies.set(key, value, {
      secure: true,
      sameSite: "strict",
      expires: 3,
    });
  },
  getItem: (key) => Cookies.get(key) ?? null,
};

export default cookieStorage;
